import { useNavigate } from "react-router-dom";
import { PageTitleConstants } from "../../Constants";
import { Card, Button, Container } from "react-bootstrap";
import { useState, useContext, useEffect } from "react";
import { downloadFileFromResponse, calculateRemainingTime } from "wup-module1-base/src/helpers";
import { faWarning } from "@fortawesome/free-solid-svg-icons/faWarning";
import UserContext from "../../Contexts/UserContext";
import { toast } from "react-toastify";
import { M1_FormApplicationStatuses } from "../../Constants";
import { SignApplicationModal } from "../../Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppHelpers } from "../../Helpers/App/AppHelpers";
import { PageHeader, Loading, toastSuccessMessage } from "wup-module1-base";
import {
  faEdit,
  faFileWord,
  faStar,
} from "@fortawesome/free-regular-svg-icons";
import {
  ClientService,
  DocumentsService,
  AttachmentsService,
  CommentsService,
  ConfigService,
  SignService,
} from "../../Services";
import {
  faArrowAltCircleUp,
  faCircleDown,
  faCircleXmark,
  faFile,
} from "@fortawesome/free-regular-svg-icons";

function ApplicationForm() {
  const { user, setUser } = useContext(UserContext);
  const [formHtml, setFormHtml] = useState();
  const navigate = useNavigate();
  const [attachments, setAttachments] = useState([]);
  const [isAttachmentsRequired, setIsAttachmentsRequired] = useState();
  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false);
  const [userApplicationStatus, setUserApplicationStatus] = useState();
  const [isContentEditable, setIsContentEditable] = useState(false);
  const [toCorrectComments, setToCorrectCommments] = useState();
  const [firstEnterData, setFirstEnterData] = useState();
  const [daysToComplete, setDaysToComplete] = useState();
  const [daysToCompleteLeft, setDaysToCompleteLeft] = useState();
  const [formUuid, setFormUuid] = useState();
  const [activeNavbar, setActiveNavbar] = useState(1);
  const [declarationDescription, setDeclarationDescription] = useState("");
  const [taskList, setTaskList] = useState();
  const [isXmlSigned, setIsXmlSigned] = useState();
  const [submitBySign, setSubmitBySign] = useState(true);
  const [workDataObj, setWorkDataObj] = useState();

  // funkcja pobierająca komentarze do wyświetlenia dla klienta
  const getUserComments = () => {
    CommentsService.getComments(user.id)
      .then((response) => {
        let commentsTab = response.data;
        setToCorrectCommments(commentsTab);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // funkcja formatująca datę
  const getCurrentDateFormatted = () => {
    let date = new Date();
    let isoString = date.toISOString();
    let [datePart, timePart] = isoString.split("Z");
    let microseconds = "000000";

    return `${datePart}${microseconds}Z`;
  };

  // funkcja wstawiająca załącznik do tablicy
  const addAttachment = (fileObj) => {
    setAttachments([...attachments, fileObj]);
  };

  // funkcja usuwająca załacznik oraz reindeksujaca tablice
  const handleDeleteAttachment = (index) => {
    AttachmentsService.deleteAttachment(index)
      .then((response) => {
        const newAttachments = attachments.filter(
          (attachment) => attachment.id !== index
        );
        setAttachments(newAttachments);
        toastSuccessMessage("Pomyślnie usunięto załącznik");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Wystąpił błąd podczas usuwania załącznika");
      });

    const newAttachments = attachments.filter((_, i) => i !== index);
    setAttachments(newAttachments);
  };

  // funkcja pobierająca załącznik
  const handleDownLoadAttachment = (index, name) => {
    AttachmentsService.downloadAttachment(index)
      .then((response) => {
        downloadFileFromResponse(response, name);
        toastSuccessMessage("Pobrano załącznik");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Wystąpił błąd podczas pobierania załącznika");
      });

    const newAttachments = attachments.filter((_, i) => i !== index);
    setAttachments(newAttachments);
  };

  // funkcja wracająca do panelu klienta
  const goBack = () => {
    navigate(`/`);
  };

  // funkcja otwierająca modal podpisu
  const openSignModal = () => {
    setIsApplicationModalOpen(true);
  };

  // funkcja zmieniająca status po pomyślnym podpisaniu formularza przez klienta na "weryfikaca w toku"
  const signForm = () => {
    let data = {
      register_status: M1_FormApplicationStatuses.ReadyToVerify.value,
    };

    ClientService.patchClientEnity(user.id, data)
      .then((response) => {
        setUserApplicationStatus(
          M1_FormApplicationStatuses.ReadyToVerify.value
        );
        setIsApplicationModalOpen(false);
        toastSuccessMessage("Podpisano pomyślnie");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Wystąpił błąd w przesłaniu");
      });
  };

  // funkcja pobierająca deklarację
  const downloadDeclaration = (indexOfDoc, name) => {
    DocumentsService.downloadDeclarationById(indexOfDoc, AppHelpers.uuidv4())
      .then((response) => {
        downloadFileFromResponse(response, name);
        toastSuccessMessage("Oświadczenie pobrane pomyślnie");
      })
      .catch((error) => {
        console.error(error);
        toast.error(`Wystąpił błąd w pobieraniu oświadczenia ${indexOfDoc}`);
      });
  };

  // funkcja ściągająca deklarację po kluczu
  const getDeclValueByKey = (key) => {
    let declaration = declarationDescription.find(
      (declaration) => declaration.key === key
    );
    return declaration ? declaration.value : null;
  };

  // funkcja dodająca załącznik do db
  const addAttachmentFile = (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("attachment", file);

    AttachmentsService.createAttachment(formData)
      .then((response) => {
        addAttachment(response.data);
        toastSuccessMessage("Dodano załącznik");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Wystąpił błąd podczas dodawania załącznika");
      });
  };

  // funkcja paska nawigacji do przełączania między widokami
  const changeNavbar = () => {
    setActiveNavbar(activeNavbar === 1 ? 2 : 1);
  };

  // funkcja do przesłania załączników, do weryfikacji
  const sentToVerify = () => {
    let url = new URL(window.location.href);
    url.search = "";
    window.history.replaceState({}, "", url);

    ClientService.updateStatusFromCorrect()
      .then((response) => {
        window.location.reload();
        toastSuccessMessage(`Przesłano do weryfikacji`);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // hook pobierający czy załączniki są wymagane do podpisu oraz pobierący datę na podpisanie FZ
  useEffect(() => {
    if (!user.isFirstRecrutation) {
      if (
        userApplicationStatus === M1_FormApplicationStatuses.Registered.value ||
        userApplicationStatus === M1_FormApplicationStatuses.ToCorrect.value
      ) {
        ConfigService.getConfigByKey(`form_is_sign_required`)
          .then((response) => {
            parseInt(response.data.value) === 1
              ? setIsAttachmentsRequired(true)
              : setIsAttachmentsRequired(false);
          })
          .catch((error) => {});
      }

      ConfigService.getConfigByKey(`form_days_for_import_attachments`)
        .then((response) => {
          setDaysToComplete(response.data.value);
        })
        .catch((error) => {});
    }

    if (
      userApplicationStatus === M1_FormApplicationStatuses.Registered.value ||
      userApplicationStatus === M1_FormApplicationStatuses.ToCorrect.value
    ) {
      ClientService.getFZdate(user.id)
        .then((response) => {
          setFirstEnterData(response.data);
          if (!response.data) {
            let obj = {};
            obj.created_at = getCurrentDateFormatted();
            setFirstEnterData(obj.created_at);
          }
        })
        .catch((error) => {});
    }
  }, [userApplicationStatus]);

  // hook pobierający dane użytkownika oraz komentarze
  useEffect(() => {
    if (!user.isFirstRecrutation) {
      ClientService.fetchClientEntity(user.id)
        .then((response) => {
          setUserApplicationStatus(response.data.register_status);
          if (
            response.data.register_status ===
            M1_FormApplicationStatuses.ToCorrect.value
          ) {
            getUserComments();
          }
        })
        .catch((error) => {
          console.error(error);
        });

      AttachmentsService.getClientAttachmentsByToken()
        .then((response) => {
          setAttachments(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, []);

  // hook ustawiający deklaracje
  useEffect(() => {
    if (!user.isFirstRecrutation) {
      ConfigService.getConfigByKey(`no_declaration_message`)
        .then((response) => {
          setDeclarationDescription((prev) => [
            ...prev,
            { key: "main_declaration", value: response.data.value },
          ]);
        })
        .catch((error) => {});

      if (!!workDataObj?.niepelnospr) {
        ConfigService.getConfigByKey(
          `no_declaration_message_for_disabled_people`
        )
          .then((response) => {
            setDeclarationDescription((prev) => [
              ...prev,
              {
                key: "disabled_person_declaration",
                value: response.data.value,
              },
            ]);
          })
          .catch((error) => {});
      }

      if (!!workDataObj?.skladki_krus) {
        ConfigService.getConfigByKey(`no_declaration_message_for_farmers`)
          .then((response) => {
            setDeclarationDescription((prev) => [
              ...prev,
              { key: "krus_declaration", value: response.data.value },
            ]);
          })
          .catch((error) => {});
      }
    }
  }, [workDataObj]);

  // hook pobierający dane dotyczaczące wymaganych deklaracji
  useEffect(() => {
    if (!!formUuid && !user.isFirstRecrutation) {
      SignService.getTaskList(formUuid, user.id)
        .then((response) => {
          setTaskList(btoa(response.data));
        })
        .catch((error) => {});

      ClientService.getWorkData()
        .then((response) => {
          setWorkDataObj(response.data);
        })
        .catch((error) => {});
    }
  }, [formUuid]);

  // hook ustawiający czas pozostały na podpisanie umowy
  useEffect(() => {
    if (!!firstEnterData && !!daysToComplete && !user.isFirstRecrutation) {
      const result = calculateRemainingTime(firstEnterData, daysToComplete);
      setDaysToCompleteLeft(result);
    }
  }, [firstEnterData, daysToComplete]);

  // hook pomocniczy do sprawdzenia czy jest możliwość edycji załączników
  useEffect(() => {
    if (!user.isFirstRecrutation) {
      const isStatusEditable =
        userApplicationStatus === M1_FormApplicationStatuses.Registered.value ||
        userApplicationStatus === M1_FormApplicationStatuses.ToCorrect.value;

      if (isStatusEditable && daysToCompleteLeft) {
        setIsContentEditable(true);
      } else {
        setIsContentEditable(false);
      }
    }
  }, [userApplicationStatus, daysToCompleteLeft]);

  // hook wyświetlający komunikaty po uzyskaniu rezultatu podpisu
  useEffect(() => {
    if (!user.isFirstRecrutation) {
      let urlParams = new URLSearchParams(window.location.search);
      let result = urlParams.get("result");
      if (
        result === "1" &&
        userApplicationStatus === M1_FormApplicationStatuses.ReadyToVerify.value
      ) {
        toast.success(
          <div>
            <FontAwesomeIcon icon={faEdit} /> Podpisano pomyślnie!
          </div>,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      }

      if (
        (userApplicationStatus ===
          M1_FormApplicationStatuses.Registered.value ||
          userApplicationStatus ===
            M1_FormApplicationStatuses.ToCorrect.value) &&
        result === "0"
      ) {
        toast.error(
          <div> Formularz nie został podpisany. Spróbuj ponownie!</div>,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      }
    }
  }, [userApplicationStatus]);

  // hook modyfikujacy html formularza zgłoszeniowego
  useEffect(() => {
    if (!!userApplicationStatus && !user.isFirstRecrutation) {
      DocumentsService.getUserForm(user.id)
        .then((response) => {
          setFormUuid(response.data.unsigned_uuid);
          let modifiedHtml = response.data.html.replace(
            /<input(?![^>]*readOnly)([^>]*)>/g,
            "<input$1 class='custom-disabled' readonly>"
          );

          modifiedHtml = modifiedHtml.replace(
            /<textarea(?![^>]*readOnly)([^>]*)>/g,
            "<textarea$1 class='custom-disabled' readonly>"
          );

          modifiedHtml = modifiedHtml.replace(
            /<select(?![^>]*readOnly)([^>]*)>/g,
            "<select$1 class='custom-disabled' readonly>"
          );

          modifiedHtml += ` <style type="text/css">
                            [readonly], .inputdiv {
                              pointer-events: none;
                              background-color: inherit;
                              color: inherit;
                              cursor: default;
                              opacity: 1;
                            }
                            </style>`;

          setFormHtml(modifiedHtml);
          setIsXmlSigned(response.data.is_signed);
          if (
            userApplicationStatus === M1_FormApplicationStatuses.ToCorrect.value
          ) {
            setSubmitBySign(!response.data.is_signed);
          }
        })
        .catch((error) => {
          toast.error("Błąd przy wczytywaniu formularza");
          console.error(error);
        });
    }
  }, [userApplicationStatus]);

  return (
    <>
      <Container className="application-form-container">
        <PageHeader content={PageTitleConstants.ApplicationForm} />
        {!!user.isFirstRecrutation ? (
          <>
            <Card className="mx-20 summary-card survey-screen application-form">
              <div className="warning-info-container">
                <div className="description-element">
                  <FontAwesomeIcon
                    icon={faWarning}
                    className="description-icon"
                  />
                  <div class="description-paragraph" data-id="33:4107">
                    Brak podglądu formularza
                  </div>
                </div>
              </div>
              <Card.Footer className="bg-white">
                <Button
                  className="btn-back"
                  variant="secondary mr-1"
                  onClick={goBack}
                >
                  Powrót
                </Button>
              </Card.Footer>
            </Card>
          </>
        ) : (
          <Card className="mx-20 summary-card survey-screen application-form">
            {M1_FormApplicationStatuses.Verified.value ===
              userApplicationStatus && (
              <div class="navbar-container">
                <button
                  type="button"
                  class={
                    activeNavbar === 1
                      ? "navbar-horizontal-btn btn btn-secondary btn-active"
                      : "navbar-horizontal-btn btn btn-secondary"
                  }
                  onClick={changeNavbar}
                >
                  Formularz zgłoszeniowy
                </button>
                <button
                  type="button"
                  class={
                    activeNavbar === 2
                      ? "navbar-horizontal-btn btn btn-secondary btn-active"
                      : "navbar-horizontal-btn btn btn-secondary"
                  }
                  onClick={changeNavbar}
                >
                  Dokumenty do druku
                </button>
              </div>
            )}
            {activeNavbar === 1 ? (
              <Card.Body className="summary-card survey-screen">
                {!!formHtml && !!userApplicationStatus ? (
                  <>
                    {!!isContentEditable ? (
                      <div className="warning-info-container">
                        <div className="description-element">
                          <FontAwesomeIcon
                            icon={faWarning}
                            className="description-icon"
                          />
                          <div class="description-paragraph" data-id="33:4107">
                            Pozostało <strong>{daysToCompleteLeft}</strong> do
                            {!!submitBySign
                              ? ` złożenia podpisu.`
                              : ` przesłania załączników.`}
                            <br></br>
                            {toCorrectComments?.length > 0 && (
                              <>
                                <br></br>
                                <strong>Uwaga: </strong>
                                {
                                  toCorrectComments[
                                    toCorrectComments.length - 1
                                  ].content
                                }
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        {(userApplicationStatus ===
                          M1_FormApplicationStatuses.Registered.value ||
                          userApplicationStatus ===
                            M1_FormApplicationStatuses.ToCorrect.value) && (
                          <div className="warning-info-container">
                            <div className="description-element">
                              <FontAwesomeIcon
                                icon={faWarning}
                                className="description-icon"
                              />
                              <div
                                class="description-paragraph"
                                data-id="33:4107"
                              >
                                Czas na podpisanie formularza zgłoszeniowego
                                upłynął.
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <iframe
                      title="embedded-content"
                      srcDoc={formHtml}
                      class="app-form-iframe"
                    />
                    {!!isContentEditable && !!isAttachmentsRequired ? (
                      <div>
                        <label for="files" class="btn btn-add-file">
                          <FontAwesomeIcon icon={faArrowAltCircleUp} />
                          Wgraj załącznik
                        </label>
                        <input
                          className="focusable"
                          tabIndex={"0"}
                          id="files"
                          type="file"
                          onChange={(e) => addAttachmentFile(e)}
                        ></input>
                      </div>
                    ) : null}
                    {attachments.length > 0 && !!isAttachmentsRequired && (
                      <div className="attachments-container">
                        <div className="font-semibold">Wgrane załączniki: </div>
                        <ul>
                          {attachments.map((item, index) => (
                            <li key={index}>
                              <FontAwesomeIcon
                                className="declaration-icon"
                                icon={faFile}
                              />
                              <span>{item.path}</span>
                              <div class="li-buttons">
                                <Button
                                  tabIndex={"0"}
                                  className="btn-download-file focusable"
                                  onClick={() =>
                                    handleDownLoadAttachment(item.id, item.path)
                                  }
                                  variant="info"
                                >
                                  <FontAwesomeIcon icon={faCircleDown} />
                                  Pobierz
                                </Button>
                                {!!isContentEditable && (
                                  <Button
                                    tabIndex={"0"}
                                    className="btn-delete-file focusable"
                                    onClick={() =>
                                      handleDeleteAttachment(item.id)
                                    }
                                    variant="danger"
                                  >
                                    <FontAwesomeIcon icon={faCircleXmark} />
                                    Usuń
                                  </Button>
                                )}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </>
                ) : (
                  <Loading />
                )}
              </Card.Body>
            ) : (
              <Card.Body className="declarations-body">
                {!!workDataObj?.skladki_krus && (
                  <div class="declaration-info">
                    <div className="info-container">
                      <div className="description-element">
                        <FontAwesomeIcon
                          icon={faStar}
                          className="description-icon"
                        />
                        <div class="description-paragraph" data-id="33:4107">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: getDeclValueByKey("krus_declaration"),
                            }}
                          />{" "}
                          <br></br>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {!!workDataObj?.niepelnospr && (
                  <div class="declaration-info">
                    <div className="info-container">
                      <div className="description-element">
                        <FontAwesomeIcon
                          icon={faStar}
                          className="description-icon"
                        />
                        <div class="description-paragraph" data-id="33:4107">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: getDeclValueByKey(
                                "disabled_person_declaration"
                              ),
                            }}
                          />{" "}
                          <br></br>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="declarations-container">
                  <div className="font-semibold">Pliki do pobrania: </div>
                  <ul>
                    {!!workDataObj?.zolniez && (
                      <li>
                        <div class="declaration-el">
                          <FontAwesomeIcon
                            className="declaration-icon"
                            icon={faFileWord}
                          />
                          <span class="declaration-name">
                            Zaświadczenie o pełnieniu terytorialnej służby
                            wojskowej
                          </span>
                          <div class="li-buttons focusable">
                            <Button
                              tabIndex={"0"}
                              className="btn-download-file"
                              variant="info"
                              onClick={() =>
                                downloadDeclaration(
                                  2,
                                  `Zaświadczenie o pełnieniu terytorialnej służby wojskowej`
                                )
                              }
                            >
                              <FontAwesomeIcon
                                className="declaration-name"
                                icon={faCircleDown}
                              />
                              Pobierz
                            </Button>
                          </div>
                        </div>
                        {!!declarationDescription && (
                          <div>
                            <div className="info-container">
                              <div className="description-element">
                                <div
                                  class="description-paragraph"
                                  data-id="33:4107"
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        getDeclValueByKey("main_declaration"),
                                    }}
                                  />{" "}
                                  <br></br>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </li>
                    )}

                    {!!workDataObj?.stazak && (
                      <li>
                        <div class="declaration-el">
                          <FontAwesomeIcon
                            className="declaration-icon"
                            icon={faFileWord}
                          />
                          <span class="declaration-name">
                            Oświadczenie o pełnieniu służby w Ochotniczej Straży
                            Pożarnej
                          </span>
                          <div class="li-buttons">
                            <Button
                              tabIndex={"0"}
                              className="btn-download-file focusable"
                              variant="info"
                              onClick={() =>
                                downloadDeclaration(
                                  4,
                                  `Oświadczenie o pełnieniu służby w Ochotniczej Straży Pożarnej`
                                )
                              }
                            >
                              <FontAwesomeIcon
                                className="declaration-name"
                                icon={faCircleDown}
                              />
                              Pobierz
                            </Button>
                          </div>
                        </div>
                        {!!declarationDescription && (
                          <div>
                            <div className="info-container">
                              <div className="description-element">
                                <div
                                  class="description-paragraph"
                                  data-id="33:4107"
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        getDeclValueByKey("main_declaration"),
                                    }}
                                  />{" "}
                                  <br></br>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </li>
                    )}

                    {!!workDataObj?.zatrud &&
                      !workDataObj?.skladki_krus &&
                      !workDataObj?.bezrop && (
                        <li>
                          <div class="declaration-el">
                            <FontAwesomeIcon
                              className="declaration-icon"
                              icon={faFileWord}
                            />
                            <span class="declaration-name">
                              Zaświadczenie o zatrudnieniu
                            </span>
                            <div class="li-buttons">
                              <Button
                                tabIndex={"0"}
                                className="btn-download-file focusable"
                                variant="info"
                                onClick={() =>
                                  downloadDeclaration(
                                    1,
                                    `Zaświadczenie o zatrudnieniu`
                                  )
                                }
                              >
                                <FontAwesomeIcon
                                  className="declaration-name"
                                  icon={faCircleDown}
                                />
                                Pobierz
                              </Button>
                            </div>
                          </div>
                          {!!declarationDescription && (
                            <div>
                              <div className="info-container">
                                <div className="description-element">
                                  <div
                                    class="description-paragraph"
                                    data-id="33:4107"
                                  >
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          getDeclValueByKey("main_declaration"),
                                      }}
                                    />{" "}
                                    <br></br>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </li>
                      )}

                    <li>
                      <div class="declaration-el">
                        <FontAwesomeIcon
                          className="declaration-icon"
                          icon={faFileWord}
                        />
                        <span class="declaration-name">
                          Oświadczenie uczestnika
                        </span>
                        <div class="li-buttons">
                          <Button
                            tabIndex={"0"}
                            className="btn-download-file focusable"
                            variant="info"
                            onClick={() =>
                              downloadDeclaration(3, `Oświadczenie uczestnika<`)
                            }
                          >
                            <FontAwesomeIcon
                              className="declaration-name"
                              icon={faCircleDown}
                            />
                            Pobierz
                          </Button>
                        </div>
                      </div>
                      {!!declarationDescription && (
                        <div>
                          <div className="info-container">
                            <div className="description-element">
                              <div
                                class="description-paragraph"
                                data-id="33:4107"
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      getDeclValueByKey("main_declaration"),
                                  }}
                                />{" "}
                                <br></br>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  </ul>
                </div>
              </Card.Body>
            )}

            {!!userApplicationStatus && (
              <Card.Footer className="bg-white">
                <Button
                  tabIndex={"0"}
                  className="btn-back focusable"
                  variant="secondary mr-1"
                  onClick={goBack}
                >
                  Powrót
                </Button>
                {(isAttachmentsRequired === false || !!isContentEditable) &&
                !!daysToCompleteLeft &&
                !!submitBySign &&
                !!formHtml ? (
                  <Button
                    tabIndex={"0"}
                    className={
                      (!!attachments && attachments.length > 0) ||
                      isAttachmentsRequired === false
                        ? "btn-next focusable"
                        : "btn-next disabled"
                    }
                    onClick={openSignModal}
                    variant="primary"
                  >
                    Podpisz
                  </Button>
                ) : null}
                {(isAttachmentsRequired === false || !!isContentEditable) &&
                !!daysToCompleteLeft &&
                !!formHtml &&
                !submitBySign ? (
                  <Button
                    tabIndex={"0"}
                    className={
                      (!!attachments && attachments.length > 0) ||
                      isAttachmentsRequired === false
                        ? "btn-next focusable"
                        : "btn-next disabled"
                    }
                    onClick={sentToVerify}
                    variant="primary"
                  >
                    Prześlij do weryfikacji
                  </Button>
                ) : null}
              </Card.Footer>
            )}
          </Card>
        )}
      </Container>
      <SignApplicationModal
        isApplicationModalOpen={isApplicationModalOpen}
        setIsApplicationModalOpen={setIsApplicationModalOpen}
        signForm={signForm}
        formUuid={formUuid}
        clientId={user.id}
        taskList={taskList}
        documentType={2}
      />
    </>
  );
}

export default ApplicationForm;
